// Auto-generated from proto definitions. DO NOT EDIT.

export type PaymentOperationType = 'PAYMENT_OPERATION_TYPE_UNSPECIFIED' | 'PAYMENT_OPERATION_TYPE_AUTHORIZE' | 'PAYMENT_OPERATION_TYPE_CAPTURE' | 'PAYMENT_OPERATION_TYPE_CHARGE' | 'PAYMENT_OPERATION_TYPE_REFUND' | 'PAYMENT_OPERATION_TYPE_VOID';

export const PaymentOperationTypeValues = ['PAYMENT_OPERATION_TYPE_UNSPECIFIED', 'PAYMENT_OPERATION_TYPE_AUTHORIZE', 'PAYMENT_OPERATION_TYPE_CAPTURE', 'PAYMENT_OPERATION_TYPE_CHARGE', 'PAYMENT_OPERATION_TYPE_REFUND', 'PAYMENT_OPERATION_TYPE_VOID'] as const;
